import { render, staticRenderFns } from "./FooterParaProductos.vue?vue&type=template&id=18d30286&scoped=true&"
import script from "./FooterParaProductos.vue?vue&type=script&lang=js&"
export * from "./FooterParaProductos.vue?vue&type=script&lang=js&"
import style0 from "./FooterParaProductos.vue?vue&type=style&index=0&id=18d30286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d30286",
  null
  
)

export default component.exports